export function updateMenuOptions(menuOptions, navigate, t) {
    menuOptions.unshift(
        {
            icon: 'logo-ohif-small',
            title: t('Header:Dashboard'),
            onClick: async () => {
                const currentPage = window.location.href;
                if (currentPage.includes('overview')) {
                    return
                } else {
                    navigate('/overview')
                }
            },
        },{
            icon: 'lock',
            title: t('Header:Staff'),
            onClick: async () => window.open(process.env.STAFF_URL, '_blank').focus(),
        }
    )

    return menuOptions
}
